import {createSelector} from 'reselect';
import {List} from 'immutable';

export const selectSearchResults = state => state.getIn(['store', 'searchResults']);

export const selectSearchText = state => state.getIn(['search', 'text']);

export const selectIsSearchFetching = state => state.getIn(['search', 'searchFetching']);

export const selectSearchResultsAsList = createSelector(
    selectSearchResults,
    searchResults => (searchResults || List()).toJS()
);
